// Copyright (c) 2017 Comsearch, Inc., All rights reserved

export const ASSIGN_USER_DATA = 'ASSIGN_USER_DATA'
